// @flow
import * as React from "react";
import { Button, Icon, Responsive } from "semantic-ui-react";
import classnames from "classnames";

import { CategoryTypes } from "../../Modules/category/misc/Types";

import Styles from "./ConsumptionButtons.module.scss";
import { COMPANY } from "Commons/Utilities/Constants/PropertyTypes";

/**
 @desciption This component is an independent set of consumption buttons, that cooperate with consumption input
 but are ultimately their own component. Meant to be used with redux-form

 How to use: put them in a redux form, and give them the category type. Make sure to have the name of the field
 identical to the input field of consumption (if you want them to work together). That's all!
 */

type Props = {|
  input: {
    value: string,
    onChange: Function,
  },
  categoryType: string,
  customStyles: Dict,
  forceMobile?: boolean,
  propertyType: string,
|};

type ButtonData = {
  label: React.Node,
  associatedValue: number,
};

type ButtonProps = {
  ...ButtonData,
  onChange: Function,
  value: number,
  customStyles: string,
  native: boolean,
  meta: Dict,
};

export class ConsumptionButtons extends React.Component<Props> {
  renderPeople(number: number) {
    return (
      <div>
        {Array.from({ length: number }).map((_, index) => (
          <Icon key={index} name={"user"} />
        ))}
      </div>
    );
  }

  renderCompany(number: number) {
    return (
      <div>
        {Array.from({ length: number }).map((_, index) => (
          <Icon key={index} name={"factory"} />
        ))}
      </div>
    );
  }

  ConsumptionLevels: { [key: string]: ButtonData[] } = {
    [CategoryTypes.ELECTRICITY]: [
      { associatedValue: 1500, label: this.renderPeople(1) },
      { associatedValue: 2500, label: this.renderPeople(2) },
      { associatedValue: 3500, label: this.renderPeople(3) },
      { associatedValue: 4250, label: this.renderPeople(4) },
    ],
    [CategoryTypes.GAS]: [
      { associatedValue: 5000, label: "50 qm" },
      { associatedValue: 12000, label: "100 qm" },
      { associatedValue: 18000, label: "150 qm" },
      { associatedValue: 20000, label: "180 qm" },
    ],
  };

  companyConsumptionLevels: { [key: string]: ButtonData[] } = {
    [CategoryTypes.ELECTRICITY]: [
      { associatedValue: 10000, label: this.renderCompany(1) },
      { associatedValue: 25000, label: this.renderCompany(2) },
      { associatedValue: 50000, label: this.renderCompany(3) },
      { associatedValue: 100000, label: this.renderCompany(4) },
    ],
    [CategoryTypes.GAS]: [
      { associatedValue: 50000, label: this.renderCompany(1) },
      { associatedValue: 100000, label: this.renderCompany(2) },
      { associatedValue: 250000, label: this.renderCompany(3) },
      { associatedValue: 500000, label: this.renderCompany(4) },
    ],
  };

  button({ label, associatedValue, value, onChange, customStyles, native, meta, ...rest }: ButtonProps): React.Node {
    const active: boolean = associatedValue ? value.toString() === associatedValue.toString() : false;

    return (
      <Button
        {...rest}
        compact
        secondary={!native}
        data-cy={"consumption-button"}
        className={classnames(Styles["consumptionButton"], customStyles)}
        active={active}
        onClick={() => onChange(associatedValue)}
        type="button"
      >
        {label}
      </Button>
    );
  }

  render() {
    const {
      categoryType,
      input: { onChange, value },
      customStyles,
      forceMobile,
      propertyType,
      ...rest
    }: Props = this.props;

    const ConsButton = this.button;

    if (categoryType !== CategoryTypes.ELECTRICITY && categoryType !== CategoryTypes.GAS) {
      return null;
    }

    let content;

    if (propertyType === COMPANY) {
      content = () => {
        return this.companyConsumptionLevels[categoryType].map((levels) => (
          <ConsButton
            {...levels}
            {...rest}
            key={"cons_button_" + levels.associatedValue}
            onChange={(ps) => onChange(ps)}
            value={value}
            customStyles={customStyles}
          />
        ));
      };
    } else {
      content = () => {
        return this.ConsumptionLevels[categoryType].map((levels) => (
          <ConsButton
            {...rest}
            {...levels}
            key={"cons_button_" + levels.associatedValue}
            onChange={(ps) => onChange(ps)}
            value={value}
            customStyles={customStyles}
          />
        ));
      };
    }

    if (forceMobile) {
      return (
        <div style={{ paddingBottom: "1rem" }}>
          <Button.Group fluid vertical>
            {content()}
          </Button.Group>
        </div>
      );
    }

    return (
      <div style={{ paddingBottom: "1rem" }}>
        <Responsive {...Responsive.onlyMobile}>
          <Button.Group fluid vertical>
            {content()}
          </Button.Group>
        </Responsive>
        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <Button.Group fluid width={4}>
            {content()}
          </Button.Group>
        </Responsive>
      </div>
    );
  }
}
